import { ventasDB } from './index'
import { obtenerProducto, guardarProducto } from './productos'
import { actualizarDeuda } from './clientes'
import { registrarSalida } from './movimientos'

export async function registrarVenta(items, total, metodoPago = 'efectivo', opciones = {}) {
  const { clienteId, clienteNombre, usuarioId, usuarioNombre } = opciones
  const venta = {
    _id: `venta_${Date.now()}`,
    tipo: 'venta',
    items,
    total,
    metodoPago,
    fecha: new Date().toISOString(),
    ...(clienteId  ? { clienteId, clienteNombre }   : {}),
    ...(usuarioId  ? { usuarioId, usuarioNombre }    : {}),
  }
  const resultado = await ventasDB.put(venta)

  // Descontar stock y registrar salidas
  for (const item of items) {
    try {
      const producto = await obtenerProducto(item._id)
      if (typeof producto.stock === 'number') {
        const stockAnterior = producto.stock
        producto.stock = Math.max(0, producto.stock - item.cantidad)
        await guardarProducto(producto)
        await registrarSalida(item._id, item.nombre, item.cantidad, stockAnterior, producto.stock, venta._id)
      }
    } catch (e) {
      // Producto no encontrado, continuar
    }
  }

  // Si es fiado, incrementar deuda del cliente
  if (metodoPago === 'fiado' && clienteId) {
    await actualizarDeuda(clienteId, total)
  }

  return resultado
}

export async function registrarAbono(clienteId, clienteNombre, monto, opciones = {}) {
  const { metodoPago = 'efectivo', recibido, cambio } = opciones
  const abono = {
    _id: `abono_${Date.now()}`,
    tipo: 'abono',
    clienteId,
    clienteNombre,
    monto,
    metodoPago,
    ...(recibido != null ? { recibido, cambio } : {}),
    fecha: new Date().toISOString(),
  }
  await ventasDB.put(abono)
  await actualizarDeuda(clienteId, -monto)
}

export async function obtenerVentas(limite = 50) {
  const result = await ventasDB.allDocs({ include_docs: true, descending: true, limit: limite })
  return result.rows.map(r => r.doc).filter(doc => !doc._id.startsWith('_design'))
}

// Consulta eficiente de ventas por rango de fechas.
// Usa el prefijo 'venta_' + timestamp en _id para evitar cargar abonos
// y limitar los documentos al rango necesario.
// desdeISO: 'YYYY-MM-DD' (límite inferior, inclusivo con 1 día de buffer tz)
// hastaISO: 'YYYY-MM-DD' (límite superior, inclusivo con 2 días de buffer tz)
export async function obtenerVentasPorPeriodo(desdeISO = null, hastaISO = null) {
  let startkey = `venta_\uffff`
  if (hastaISO) {
    const h = new Date(hastaISO + 'T00:00:00')
    h.setDate(h.getDate() + 2)
    startkey = `venta_${h.getTime()}`
  }

  let endkey = 'venta_'
  if (desdeISO) {
    const d = new Date(desdeISO + 'T00:00:00')
    d.setDate(d.getDate() - 1)
    endkey = `venta_${d.getTime()}`
  }

  const result = await ventasDB.allDocs({ include_docs: true, descending: true, startkey, endkey })
  return result.rows.map(r => r.doc)
}

export async function obtenerMovimientosCliente(clienteId) {
  const result = await ventasDB.find({ selector: { clienteId } })
  return result.docs.sort((a, b) => b.fecha.localeCompare(a.fecha))
}

/**
 * Estructura para reportes futuros:
 * - ventasPorDia(fecha)
 * - ventasPorProducto()
 * - totalDelDia()
 */
